
<template>
  <div class="main-content">
    <!-- 导航区域 :ml-citation{ref="4,5" data="citationList"} -->
    <div class="left-nav">
      <div 
        class="left-nav-item" 
        v-for="nav in list" 
        :key="nav.id"
        :class="{ 'active': active === nav.id }"
        @click="changeNav(nav.id)"
      >
        {{ nav.name }}
      </div>
    </div>

    <!-- 内容展示区 :ml-citation{ref="3,6" data="citationList"} -->
    <div class="right-content">
      <div 
        class="con-item" 
        v-for="item in list" 
        :key="item.id"
        :ref="item.id"
      >
        <p class="title">{{ item.name }}</p>
        <p 
          v-if="item.desc" 
          class="desc" 
          :class="{ 'no': item.no }"
        >
          {{ item.desc }}
        </p>

        <!-- 嵌套数据展示 :ml-citation{ref="6,8" data="citationList"} -->
        <div v-if="item.itemList" class="preview-box special">
          <div 
            class="box-item-preview" 
            v-for="sub in item.itemList" 
            :key="sub.id"
          >
            <div class="item-show">
              <i 
                :class="'iconfont ' + sub.icon"
                role="img" 
                :aria-label="sub.name"
              ></i>
              <span class="item-tag">{{ item.type }}</span>
              <p class="title">{{ sub.name }}</p>
              <p 
                class="rule-item" 
                v-for="(rule, index) in sub.rules" 
                :key="index"
              >
                {{ rule }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'auth-rule',
    data() {
      return {
        active: 'primary',
        list: [
          {name: '初级能力认证规则', type: '初级', id: 'primary', itemList: [
            {name: '认证证书', icon: 'iconEMI_huaban', rules: ['1. 小米广告营销认证初级优化师', '2. 小米广告营销认证销售顾问']},
            {name: '认证对象', icon: 'iconEMI-28', rules: ['小米效果广告核心代理商销售/优化/运营人员']},
            {name: '报考流程', icon: 'iconEMI-4', rules: ['每年第三季度为报考期', '申请初级认证人员报名至各核心代理负责人处，以代理商为单位统一报名']},
            {name: '考核范围', icon: 'iconEMI-8', rules: ['包括但不限于小米认知，商业产品，资源审核，平台功能，账户操作，广告优化，数据分析等']},
            {name: '考试方式', icon: 'iconEMI-5', rules: ['由小米指定统一地点，在线完成考试']},
            {name: '有效期限', icon: 'iconEMI-14', rules: ['证书有效期为1年']},
          ]},
          {name: '中级能力认证规则', type: '中级', id: 'intermediate', itemList: [
            {name: '认证证书', icon: 'iconEMI_huaban', rules: ['1. 小米广告营销认证中级优化师', '2. 小米广告营销认证资深销售顾问']},
            {name: '认证对象', icon: 'iconEMI-28', rules: ['小米效果广告核心代理商销售/优化/运营人员', '申请中级认证，必须先通过初级认证']},
            {name: '报考流程', icon: 'iconEMI-4', rules: ['由小米发起中级认证邀请，双方确认后参与']},
            {name: '考核范围', icon: 'iconEMI-8', rules: ['包括但不限于小米认知，商业产品，资源审核，平台功能，账户操作，广告优化，数据分析等']},
            {name: '考试方式', icon: 'iconEMI-5', rules: ['由小米指定统一地点，在线完成考试']},
            {name: '有效期限', icon: 'iconEMI-14', rules: ['证书有效期为1年']},
          ]},
          {name: '高级能力认证规则', type: '高级', id: 'senior', desc: 'COMING SOON', no: true}
        ]
      }
    },
    methods: {
      changeNav(id) {
        this.active = id;
        this.scrollTo(this.$refs[id][0]);
      },
      scrollTo(el) {
        let rect = el.getBoundingClientRect();
        window.scrollTo(0, rect.top + window.scrollY);
      }
    }
  }
</script>